import { RootState } from '../../../store/store';

export const mapState = (state: RootState) => ({
  packages: state.cycles.packages,
});
